import { ReactNode } from 'react'
import {
    Delete as DeleteIcon,
    Done as DoneIcon,
    Undo as UndoIcon,
    Person as PersonIcon,
    Directions as DirectionsBoatIcon,
    SignalCellularAlt as SignalCellularAltIcon,
    GpsFixed as GpsFixedIcon,
} from '@mui/icons-material'
import { Stack, Tooltip, IconButton, Paper } from '@mui/material'
import { styled } from '@mui/material/styles'
import { UniversalAccordion, Grid } from '../UniversalComponents'

const UserNotifications = ({
    userNotifications,
    handleDeleteNotification,
    handleMarkAsRead,
}) => {
    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: 'rgba(98, 98, 98, 1) 69%,',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: 'theme.palette.text.secondary',
        marginBottom: 5,
    }))

    const UserNotificationStyling = (userNotificationType: string) => {
        let style: object = { marginBottom: 10 }
        switch (userNotificationType) {
            case 'notifyUserChanges':
                style = { ...style, backgroundColor: 'green' }
                break
            case 'notifyBoatChanges':
                style = { ...style, backgroundColor: 'blue' }
                break
            case 'notifyBoatSignal':
                style = { ...style, backgroundColor: 'red' }
                break
            case 'notifyGeofencing':
                style = { ...style, backgroundColor: 'purple' }
                break
            default:
        }
        return style
    }

    const notificationIcon = (type) => {
        const iconStyle = { fontSize: 30, marginTop: 8 }
        let icon: ReactNode
        switch (type) {
            case 'notifyUserChanges':
                icon = <PersonIcon sx={iconStyle} />
                break
            case 'notifyBoatChanges':
                icon = <DirectionsBoatIcon sx={iconStyle} />
                break
            case 'notifyBoatSignal':
                icon = <SignalCellularAltIcon sx={iconStyle} />
                break
            case 'notifyGeofencing':
                icon = <GpsFixedIcon sx={iconStyle} />
                break
            default:
        }
        return icon
    }

    return (
        <Stack sx={{ height: 500, overflowX: 'hidden' }}>
            {userNotifications &&
                userNotifications.length !== 0 &&
                userNotifications.map(
                    ({
                        _id,
                        userNotificationType,
                        userNotificationSubject,
                        userNotificationMessage,
                        updatedAt,
                        read,
                    }) => (
                        <Grid
                            key={_id}
                            container
                            sx={{
                                background: '#333',
                                borderRadius: 1,
                                opacity: read ? 0.6 : 1,
                                transition: 'opacity 0.3s ease',
                            }}
                        >
                            <Grid
                                item
                                xs={1}
                                sx={{ marginBottom: 4, marginTop: -2 }}
                            >
                                {notificationIcon(userNotificationType)}
                            </Grid>

                            <Grid item xs={10}>
                                <Grid container>
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            marginBottom: 2,
                                            marginTop: 2,
                                        }}
                                    >
                                        <UniversalAccordion
                                            fullSizeButton={12}
                                            accordionStyle={{
                                                background:
                                                    'rgba(98, 98, 98, 1) 69%,',
                                            }}
                                            summaryStyle={{
                                                background:
                                                    'rgba(98, 98, 98, 1) 69%,',
                                            }}
                                            accordionTitle={
                                                userNotificationSubject
                                            }
                                            accordionTitleDescription={
                                                userNotificationSubject
                                            }
                                        >
                                            {userNotificationMessage}
                                        </UniversalAccordion>
                                    </Grid>
                                    <Grid size={12}>
                                        {`Most Recent: ${new Date(updatedAt)
                                            .toString()
                                            .substring(0, 25)}`}
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid
                                item
                                xs={1}
                                sx={{
                                    background: 'rgba(158, 235, 71, 1) 69%,',
                                }}
                            >
                                <Stack
                                    alignItems="center"
                                    spacing={1}
                                    sx={{ marginTop: 2, padding: 1 }}
                                >
                                    <Tooltip
                                        title={
                                            read
                                                ? 'Mark as Unread'
                                                : 'Mark as Read'
                                        }
                                        key={`${_id}.markAsRead`}
                                    >
                                        <IconButton
                                            aria-label={
                                                read
                                                    ? 'mark as unread'
                                                    : 'mark as read'
                                            }
                                            onClick={() =>
                                                handleMarkAsRead(_id)
                                            }
                                            sx={{
                                                background: read
                                                    ? 'rgba(158, 235, 71, 1) 69%,'
                                                    : 'rgba(158, 235, 71, 1) 69%,',
                                                color: 'primary',
                                                transition:
                                                    'background 0.3s ease',
                                            }}
                                        >
                                            {read ? <UndoIcon /> : <DoneIcon />}
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip
                                        title="Delete Notification"
                                        key={`${_id}.delete`}
                                    >
                                        <IconButton
                                            aria-label="delete"
                                            onClick={() =>
                                                handleDeleteNotification(_id)
                                            }
                                            sx={{
                                                background:
                                                    'rgba(158, 235, 71, 1) 69%,',
                                            }}
                                            style={{
                                                marginTop: 45,
                                                marginBottom: 1,
                                            }}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                            </Grid>
                        </Grid>
                    )
                )}
        </Stack>
    )
}

export default UserNotifications
